module.exports = __webpack_public_path__ + "img/fiveday1-2.fc477212.jpg";